import api from "../api";
import { connect } from 'twilio-video';


export default class VideoChatService {


  async getAuthToken(participantName, companyId) {
    const auth = await api.get(`Twilio/token/${participantName}/${companyId}`);
    return auth.data.token;
  }

  async getAllRooms(companyId,joinId) {
    return await api.get(`Twilio/rooms/${joinId}/${companyId}`);
  }

  async joinRooms(joinId, companyId) {
      return await api.get(`Twilio/rooms/${encodeURIComponent(joinId)}/${companyId}`);
  }

  async cancelRoom(roomSid, companyId) {
    return await api.get(`Twilio/cancel/${encodeURIComponent(roomSid)}/${companyId}`);
  }

  async joinOrCreateRoom(participantName, name, tracks, companyId) {
    let room = null;
    try {
      const token = await this.getAuthToken(participantName, companyId);
      room = await connect(token, {
        name,
        tracks,
        dominantSpeaker: true,
      });
    } catch (error) {
      console.error(`Unable to connect to Room: ${error.message}`);
    } finally {
      if (room) {
      }
    }
    return room;
  }

  // nudge() {
  //   this.roomBroadcast.next(true);
  // }
}



export class MuteUnmuteOptions {
  audio;
  video;
  constructor() {
    this.audio = false;
    this.video = false;
  }
}

export class RoomsStatusRequest {
  CompanyId;
  ObjectId;
  RefId;
  ParticipantName;
  ParticipantIdentity;
  ParticipantSid;
}

export class TwilioVideoCall {
  id;
  roomId;
  roomName;
  refId;
  objectName;
  joinId;
  participants;
  constructor() {
    this.id = null;
    this.roomId = null;
    this.roomName = null;
    this.refId = null;
    this.objectName = null;
    this.joinId = null;
    this.participants = [];
  }
}
export class TwilioVideoCallParticipants {
  id;
  identity;
  constructor() {
    this.id = null;
    this.identity = null;
  }
}
